<div class="flex flex-row gap-x-2">
	@for (tag of displayedTags; track tag) {
		<div
			class="center text-s relative inline-block select-none whitespace-nowrap rounded-full bg-blue-200 px-2 py-1 align-baseline capitalize leading-none text-black">
			{{ tag.label }}
		</div>
	}
	@if (hasMore) {
		<div
			class="center text-s relative inline-block select-none whitespace-nowrap rounded-full bg-gray-300 px-2 py-1 align-baseline leading-none text-black">
			…
		</div>
	}
</div>
